import { Box, Typography } from "@mui/material";

import { cloudZeroTxt } from "../../assets/texts/CloudZero/cloudzero";

const CloudZeroTooltip = () => (
  <Box sx={{ p: 1, maxWidth: 300 }}>
    <Typography variant="body2" sx={{ mb: 1 }}>
      {cloudZeroTxt.TOOLTIP_DESCRIPTION}
    </Typography>
  </Box>
);

export default CloudZeroTooltip;
